import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=4f5006c2&scoped=true"
import script from "./RadioItem.vue?vue&type=script&lang=js"
export * from "./RadioItem.vue?vue&type=script&lang=js"
import style0 from "./RadioItem.vue?vue&type=style&index=0&id=4f5006c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5006c2",
  null
  
)

export default component.exports